/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import InvoiceAutomation from './InvoiceAutomation'

/**
 * The InlineResponse20020 model module.
 * @module model/InlineResponse20020
 * @version 1.0.0
 */
export default class InlineResponse20020 {
  /**
   * Constructs a new <code>InlineResponse20020</code>.
   * @alias module:model/InlineResponse20020
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20020</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20020} obj Optional instance to populate.
   * @return {module:model/InlineResponse20020} The populated <code>InlineResponse20020</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20020()

      if (data.hasOwnProperty('invoice_automation')) {
        obj['invoice_automation'] = InvoiceAutomation.constructFromObject(data['invoice_automation'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/InvoiceAutomation} invoice_automation
   */
  invoice_automation = undefined
}
